import { render, staticRenderFns } from "./CadastroProcedimentoPrazo.vue?vue&type=template&id=755d6c3a&"
import script from "./CadastroProcedimentoPrazo.vue?vue&type=script&lang=js&"
export * from "./CadastroProcedimentoPrazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports